export default {
  title: {
    nl: ''
  },

  text: {
    nl: 'Log in met je McDonald’s account om dit spel te spelen. Waar wacht je op?'
  },

  button: {
    nl: 'Inloggen'
  }
};
